import React from 'react'
import { View, StyleSheet } from 'react-native'
import { CustomText } from '../text/StyledText'
import { txt } from '../../locales/i18n'
import Colors from '../../constants/Colors'
import { ShadowStyles } from '../../styles'
import moment from 'moment'
import TextLabel from '../views/LearnDanish/TextLabel'

export default class AllSessions extends React.Component {
  constructor(props) {
    super(props)

    //sets locale to danish time
    moment.locale([txt('videoChat.locale')])

    this.state = {
      currentItem: '',
    }
  }

  updateSessions = (shouldUpdate) => {
    if (shouldUpdate) {
      this.setAllSessions()
    }
  }

  formatUnixDate(date) {
    var d = moment(date).format('dddd [d.] DD/MM [kl.] HH:mm')
    return d.charAt(0).toUpperCase() + d.substr(1)
  }

  render() {
    return (
      <View style={styles.container}>
        {!this.props.sessions?.length ? (
          <View>
            <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
              {txt('videoChat.allSessions')}
            </CustomText>
            <CustomText style={styles.noSession}>{txt('videoChat.noAllSessions')}</CustomText>
          </View>
        ) : (
          <View>
            <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
              {txt('videoChat.allSessions')}
            </CustomText>
            {this.props.sessions.map((item, key) => {
              var date = this.formatUnixDate(item.start_date)
              return (
                <View key={key} style={item.booked === 1 ? styles.sessionContainerBooked : styles.sessionContainer}>
                  <View style={{ flex: 2 }}>
                    <CustomText font="small">{date}</CustomText>
                    <CustomText font="small">
                      {txt('videoChat.duration')}:{' '}
                      {(new Date(item.end_date).getTime() - new Date(item.start_date).getTime()) / 1000 / 60}
                      {' min.'}
                    </CustomText>
                    <CustomText font="small">
                      {txt('videoChat.volunteer')}: {item.username}
                    </CustomText>
                    {item.booked_username && !item.junior && this.props.service !== 'snaksammen' && (
                      <CustomText font="small">
                        {txt('videoChat.bookedBy')}: {item.booked_username}
                      </CustomText>
                    )}
                    {!!item.booked && item.junior && (
                      <CustomText font="small">
                        {txt('videoChat.bookedBy') +
                        ': ' +
                        item.juniorName +
                        ' - ' +
                        item.juniorAge +
                        ' ' +
                        txt('learnDanish.junior.juniorAge')}
                      </CustomText>
                    )}
                    <View style={{flexDirection: 'row', flexWrap: 'wrap'}}>
                      {item.categories?.map(id => (
                        <TextLabel key={id} text={txt(`learnDanish.categories.${id}`)}
                                   style={{ marginRight: 6, marginTop: 6 }} />
                      ))}
                      {item.junior && <TextLabel junior style={{ marginTop: 6 }} />}
                    </View>
                  </View>
                </View>
              )
            })}
          </View>
        )}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    margin: 10,
  },
  noSession: {
    color: Colors.inactive,
    marginTop: 10,
    textAlign: 'center',
  },
  sessionContainer: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    flexDirection: 'row',
    marginTop: 10,
    padding: 10,
    ...ShadowStyles.shadowInputs,
  },
  sessionContainerBooked: {
    backgroundColor: '#97E17D',
    borderRadius: 10,
    flexDirection: 'row',
    marginTop: 10,
    padding: 10,
    ...ShadowStyles.shadowInputs,
  },
  titleBold: {
    textAlign: 'center',
    marginVertical: 6,
  },
})
